import { z } from 'zod';

export const WallpaperI18nRow = z.object({
  wallpaper_id: z.number().int().positive(),
  lang_code: z.enum(['pl', 'en', 'de', 'cs', 'uk']),
  name: z.string().min(1),
  alt: z.string().nullable(),
  uri: z.string().min(1),
  seo_title: z.string().nullable(),
  seo_description: z.string().nullable(),
  seo_h1: z.string().nullable(),
  seo_text: z.string().nullable(),
});
export type WallpaperI18n = z.infer<typeof WallpaperI18nRow>;

// uri themes: kwiaty=flower*, morze=sea*, gory=mountain*, miasto=city*, abstrakcja=abstract*
// Pattern: [theme]-[id suffix] for PL, english equiv for EN
const BASE_DATA: Array<{ wallpaper_id: number; theme: string; themeEn: string; idx: number }> = [
  // kwiaty group (1001-1005, 1026,1031,1036,1041,1046)
  { wallpaper_id: 1001, theme: 'kwiaty', themeEn: 'flowers', idx: 1 },
  { wallpaper_id: 1002, theme: 'kwiaty', themeEn: 'flowers', idx: 2 },
  { wallpaper_id: 1003, theme: 'kwiaty', themeEn: 'flowers', idx: 3 },
  { wallpaper_id: 1004, theme: 'kwiaty', themeEn: 'flowers', idx: 4 },
  { wallpaper_id: 1005, theme: 'kwiaty', themeEn: 'flowers', idx: 5 },
  // morze group (1006-1010)
  { wallpaper_id: 1006, theme: 'morze', themeEn: 'sea', idx: 1 },
  { wallpaper_id: 1007, theme: 'morze', themeEn: 'sea', idx: 2 },
  { wallpaper_id: 1008, theme: 'morze', themeEn: 'sea', idx: 3 },
  { wallpaper_id: 1009, theme: 'morze', themeEn: 'sea', idx: 4 },
  { wallpaper_id: 1010, theme: 'morze', themeEn: 'sea', idx: 5 },
  // gory group (1011-1015)
  { wallpaper_id: 1011, theme: 'gory', themeEn: 'mountains', idx: 1 },
  { wallpaper_id: 1012, theme: 'gory', themeEn: 'mountains', idx: 2 },
  { wallpaper_id: 1013, theme: 'gory', themeEn: 'mountains', idx: 3 },
  { wallpaper_id: 1014, theme: 'gory', themeEn: 'mountains', idx: 4 },
  { wallpaper_id: 1015, theme: 'gory', themeEn: 'mountains', idx: 5 },
  // miasto group (1016-1020)
  { wallpaper_id: 1016, theme: 'miasto', themeEn: 'city', idx: 1 },
  { wallpaper_id: 1017, theme: 'miasto', themeEn: 'city', idx: 2 },
  { wallpaper_id: 1018, theme: 'miasto', themeEn: 'city', idx: 3 },
  { wallpaper_id: 1019, theme: 'miasto', themeEn: 'city', idx: 4 },
  { wallpaper_id: 1020, theme: 'miasto', themeEn: 'city', idx: 5 },
  // abstrakcja group (1021-1025)
  { wallpaper_id: 1021, theme: 'abstrakcja', themeEn: 'abstract', idx: 1 },
  { wallpaper_id: 1022, theme: 'abstrakcja', themeEn: 'abstract', idx: 2 },
  { wallpaper_id: 1023, theme: 'abstrakcja', themeEn: 'abstract', idx: 3 },
  { wallpaper_id: 1024, theme: 'abstrakcja', themeEn: 'abstract', idx: 4 },
  { wallpaper_id: 1025, theme: 'abstrakcja', themeEn: 'abstract', idx: 5 },
  // second batch
  { wallpaper_id: 1026, theme: 'kwiaty', themeEn: 'flowers', idx: 6 },
  { wallpaper_id: 1027, theme: 'morze', themeEn: 'sea', idx: 6 },
  { wallpaper_id: 1028, theme: 'gory', themeEn: 'mountains', idx: 6 },
  { wallpaper_id: 1029, theme: 'miasto', themeEn: 'city', idx: 6 },
  { wallpaper_id: 1030, theme: 'abstrakcja', themeEn: 'abstract', idx: 6 },
  { wallpaper_id: 1031, theme: 'kwiaty', themeEn: 'flowers', idx: 7 },
  { wallpaper_id: 1032, theme: 'morze', themeEn: 'sea', idx: 7 },
  { wallpaper_id: 1033, theme: 'gory', themeEn: 'mountains', idx: 7 },
  { wallpaper_id: 1034, theme: 'miasto', themeEn: 'city', idx: 7 },
  { wallpaper_id: 1035, theme: 'abstrakcja', themeEn: 'abstract', idx: 7 },
  { wallpaper_id: 1036, theme: 'kwiaty', themeEn: 'flowers', idx: 8 },
  { wallpaper_id: 1037, theme: 'morze', themeEn: 'sea', idx: 8 },
  { wallpaper_id: 1038, theme: 'gory', themeEn: 'mountains', idx: 8 },
  { wallpaper_id: 1039, theme: 'miasto', themeEn: 'city', idx: 8 },
  { wallpaper_id: 1040, theme: 'abstrakcja', themeEn: 'abstract', idx: 8 },
  { wallpaper_id: 1041, theme: 'kwiaty', themeEn: 'flowers', idx: 9 },
  { wallpaper_id: 1042, theme: 'morze', themeEn: 'sea', idx: 9 },
  { wallpaper_id: 1043, theme: 'gory', themeEn: 'mountains', idx: 9 },
  { wallpaper_id: 1044, theme: 'miasto', themeEn: 'city', idx: 9 },
  { wallpaper_id: 1045, theme: 'abstrakcja', themeEn: 'abstract', idx: 9 },
  { wallpaper_id: 1046, theme: 'kwiaty', themeEn: 'flowers', idx: 10 },
  { wallpaper_id: 1047, theme: 'morze', themeEn: 'sea', idx: 10 },
  { wallpaper_id: 1048, theme: 'gory', themeEn: 'mountains', idx: 10 },
  { wallpaper_id: 1049, theme: 'miasto', themeEn: 'city', idx: 10 },
  { wallpaper_id: 1050, theme: 'abstrakcja', themeEn: 'abstract', idx: 10 },
];

function buildI18n(d: { wallpaper_id: number; theme: string; themeEn: string; idx: number }): WallpaperI18n[] {
  return [
    {
      wallpaper_id: d.wallpaper_id,
      lang_code: 'pl',
      name: `Tapeta ${d.theme} nr ${d.idx}`,
      alt: null,
      uri: `${d.theme}-${d.idx}`,
      seo_title: `Tapeta ${d.theme} ${d.idx} - fototapeta na wymiar | wandero.pl`,
      seo_description: `Zamów fototapetę ${d.theme} nr ${d.idx} w dowolnym rozmiarze. Wysoka jakość druku, szybka dostawa.`,
      seo_h1: `Fototapeta ${d.theme} ${d.idx}`,
      seo_text: null,
    },
    {
      wallpaper_id: d.wallpaper_id,
      lang_code: 'en',
      name: `Wallpaper ${d.themeEn} no ${d.idx}`,
      alt: null,
      uri: `${d.themeEn}-${d.idx}`,
      seo_title: `Wallpaper ${d.themeEn} ${d.idx} - custom photo mural | wandero.pl`,
      seo_description: `Order custom ${d.themeEn} wallpaper no ${d.idx} in any size. High quality print, fast delivery.`,
      seo_h1: `Photo Wallpaper ${d.themeEn} ${d.idx}`,
      seo_text: null,
    },
  ];
}

export const WALLPAPERS_I18N: readonly WallpaperI18n[] = BASE_DATA.flatMap(buildI18n);

WALLPAPERS_I18N.forEach((p) => WallpaperI18nRow.parse(p));
